import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton } from '@lux/wardrobe-lib'
import './DialogRedo.scss'
import RedoItem from './RedoItem'

export interface DialogRedoItem {
    value: any
    saved: any
    opened: boolean
    checked: boolean
}

const DialogRedo = (props: {
    dialogVisible: boolean
    onConfirm: (question: string, task: string, survey: string) => void
    onHide: () => void
    hideQuestion?: boolean
    hideTask?: boolean
    hideSurvey?: boolean
}) => {
    const { dialogVisible, onConfirm, onHide, hideQuestion, hideTask, hideSurvey } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-dialog-redo'

    const [disabledConfirmButton, setDisabledConfirmButton] = useState<boolean>(true)

    const [questions, setQuestions] = useState<DialogRedoItem>({
        value: '',
        saved: '',
        opened: true,
        checked: false,
    })

    const [tasks, setTasks] = useState<DialogRedoItem>({
        value: '',
        saved: '',
        opened: true,
        checked: false,
    })

    const [surveys, setSurveys] = useState<DialogRedoItem>({
        value: '',
        saved: '',
        opened: true,
        checked: false,
    })

    const renderFooter = () => {
        return (
            <div className={`${componentClass}__buttons`}>
                <LuxButton
                    disabled={disabledConfirmButton}
                    onClick={() => onConfirm(questions.saved, tasks.saved, surveys.saved)}
                    text={intl.formatMessage({
                        id: 'modals.dialog.redo_dialog.button.confirm',
                        defaultMessage: 'Confirm',
                    })}
                />
            </div>
        )
    }

    useEffect(() => {
        if (questions.saved.length > 0 || tasks.saved.length > 0 || surveys.saved.length > 0) {
            setDisabledConfirmButton(false)
        } else {
            setDisabledConfirmButton(true)
        }
    }, [questions, tasks, surveys])

    return (
        <Dialog
            header={''}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '25vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div className={componentClass}>
                <h1 className={`${componentClass}__title`}>
                    {intl.formatMessage({
                        id: 'modals.dialog.redo_dialog.title',
                        defaultMessage: 'Redo Reasons',
                    })}
                </h1>
                <div className={`${componentClass}__subtitle`}>
                    {intl.formatMessage({
                        id: 'modals.dialog.redo_dialog.description',
                        defaultMessage:
                            'To continue, select the Section to redo and add information.',
                    })}
                </div>
                <div className={`${componentClass}__checkboxes`}>
                    {!hideQuestion && (
                        <RedoItem
                            item={questions}
                            setItem={setQuestions}
                            checkboxLabel={intl.formatMessage({
                                id: 'modals.news_execution.approval.stores_detail.project_details.questions',
                                defaultMessage: 'Questions',
                            })}
                        />
                    )}
                    {!hideTask && (
                        <RedoItem
                            item={tasks}
                            setItem={setTasks}
                            checkboxLabel={intl.formatMessage({
                                id: 'modals.news_execution.approval.stores_detail.project_details.tasks',
                                defaultMessage: 'Tasks',
                            })}
                        />
                    )}
                    {!hideSurvey && (
                        <RedoItem
                            item={surveys}
                            setItem={setSurveys}
                            checkboxLabel={intl.formatMessage({
                                id: 'modals.news_execution.approval.stores_detail.project_details.surveys',
                                defaultMessage: 'Surveys',
                            })}
                        />
                    )}
                </div>
            </div>
        </Dialog>
    )
}

export default DialogRedo
